import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { GeozonesService } from '@services/geozones.service';
import {
  loadGeozonesGroups,
  loadGeozonesGroupsFailure,
  loadGeozonesGroupsSuccess,
} from '@store/geozoneGroups/geozoneGroups.actions';
import { setGeozonesLoading } from '@store/geozones/geozones.actions';

@Injectable()
export class GeozonesGroupsEffects {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(GeozonesService);
  private readonly store = inject(Store);

  loadGeozonesGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadGeozonesGroups),
      exhaustMap(() => {
        this.store.dispatch(setGeozonesLoading({ loading: true }));
        return this.apiService.geozonesGroupList().pipe(
          map((list: any) => {
            this.store.dispatch(setGeozonesLoading({ loading: false }));
            return loadGeozonesGroupsSuccess({ list });
          }),
          catchError((error) => {
            this.store.dispatch(setGeozonesLoading({ loading: false }));
            return of(loadGeozonesGroupsFailure({ error: error.message }));
          }),
        );
      }),
    ),
  );
}
